import React, { forwardRef, useImperativeHandle, useState } from 'react'
import './modals.css'
import { Modal } from 'react-bootstrap';
import closeIcon from '../../assets/close.svg'

const ModalWrapper: React.ForwardRefRenderFunction<any, any> = ({ callback, title, children }, ref) => {
  
    const [showWrapper, setShowWrapper] = useState<boolean>(false)

    useImperativeHandle(ref, () => ({
        
        toggleModalWrapper: (bool: boolean) => { setShowWrapper(bool) }

    }), []);

    // console.log(props, ref);
    

    const closeModal = () => {
        if (typeof callback === 'function') {
            callback()
        }
        setShowWrapper(false)
    }

    const onModalOpens = () => {
        const body = document.getElementById('MFCentralAdminBody')
        if (body !== null) {
            body.classList.add('remove-padding')
        }
    }

  return (
    <Modal show={showWrapper} className="mf-cenrtal-modal" centered backdrop='static' onEntered={onModalOpens}>
        <Modal.Header className='justify-content-center mf-central-modal-header border-0 position-relative'>
            <div className="cursor-pointer mf-modal-close text-center" onClick={closeModal}>
                <img width="25" height="25" src={closeIcon} alt="close" />
            </div>
            <Modal.Title className='text-sec-color'><strong>{ title }</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            { children }
        </Modal.Body>
    </Modal>
  )

}

export default forwardRef(ModalWrapper)